export default __webpack_public_path__ + "static/media/Yenepoya Photos-6.3d464bb5.png";